import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const TitleMultipleQuotesStyle = styled('div')`
    .title-detail {
        padding: 36px 0;
        background: var(--burgundy-800);
    }
    .sub-title {
        font-weight: 500;
        color: var(--sand-600);
        background-color: var(--sand-200);
        font-size: 20px;
        padding: 22px 0;
    }
    .box-multiple-title {
        background: var(--burgundy-800);
        color: var(--white);
        padding: 22px 0;

        .box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
            gap: 16px;

            .text-current {
                color: var(--orange-300);
                ${typography.tertiary}

                .icon-circle {
                    cursor: pointer;
                    font-size: 36px;
                    color: var(--orange-300);
                    &.disabled {
                        cursor: not-allowed;
                        opacity: 0.65;
                    }
                }
            }
            .text-compare {
                font-weight: 700;
                cursor: pointer;
                text-align: right;
                font-size: 1.15rem;
                span {
                    text-decoration-line: underline;
                }
            }
        }
    }

    .sticky-active {
        padding-top: 114px;
        .box-multiple-title {
            width: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 99;
        }
    }

    &.multiple {
        .title-detail {
        }

        .sub-title {
            font-size: 20px;
            padding: 22px 0;
        }
    }

    @media screen and (min-width: 1200px) {
        .box-multiple-title {
            .box {
                .text-compare {
                    font-size: 21px;
                }
            }
        }
    }

    @media screen and (max-width: 767px) {
        .title-detail {
            padding: 18px 0;

            .sub-title {
                font-size: 20px;
            }
        }
    }

    @media screen and (max-width: 410px) {
        .box-multiple-title {
            .box {
                .text-current {
                    white-space: nowrap;
                    .icon-circle {
                        font-size: 32px;
                    }
                }
                .text-compare {
                    font-size: 16px;
                }
            }
        }
    }
`;

export default TitleMultipleQuotesStyle;
